import { Box, Text } from '@chakra-ui/react'
import type { InsuranceParamsTravelDto, PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { formatPersonFullName } from 'BrokerTsLib/src/dtos'
import moment from 'moment'
import { useContext } from 'react'

import { Selection } from 'BrokerTsLib/src/enums'
import { Card, CardBody } from '../components/Card'
import { Loading } from '../components/Loading'
import { useApp } from '../hooks/useApp'
import { insuranceParamsContext } from '../layouts/Wizard'

const InsuranceSummaryItem = ({ label, value }: { label: string; value: string | number | React.ReactNode }) => {
  return (
    <Box sx={{ display: 'grid', gap: 1, alignContent: 'start', justifyItems: 'start' }}>
      <Text sx={{ fontSize: 'sm', fontWeight: 'semibold', lineHeight: 'body' }}>{label}</Text>
      <Text sx={{ color: 'primary.400', fontSize: 'lg', fontWeight: 'medium' }}>{value}</Text>
    </Box>
  )
}

const getRcIcoHeader = (person?: PersonAdditionalData) => {
  if (!person) return ''

  return person.type == Selection.Person || person.type == Selection.SelfEmployed
    ? (person.birthNumber ? 'RČ' : 'Datum narození')
    : 'IČO'
}

const getRcIcoValue = (person?: PersonAdditionalData) => {
  if (!person) return ''

  if (person.type == Selection.Person || person.type == Selection.SelfEmployed) {
    if (person.birthNumber) {
      return person.birthNumber
    }
    else {
      return moment(new Date(person.birthday!)).format('D. M. YYYY')
    }
  }
  else
    return person.idendificationNumber
}

export const InsuranceSummary = ({ version = 'standart' }: { version?: 'addon' | 'standart' }) => {
  const { insuranceParams, isLoadingData } = useContext(insuranceParamsContext)
  const { app } = useApp()
  const ph = insuranceParams?.policyHolder?.person
  let phone = ph?.mobilePhone // předvolbu zobrazujeme pouze u čísel, která nejsou tuzemská
  if (phone && ph?.mobilePhonePrefix && ph.mobilePhonePrefix != '+420') {
    phone = ph?.mobilePhonePrefix + phone
  }
  if (!phone) {
    phone = ph?.phone
  }

  const cellsCount = app == 'cestovko' ? 6 : 5

  return (
    <Card>
      {isLoadingData && <Loading large={true} />}
      {!isLoadingData && !!insuranceParams &&
        <CardBody
          sx={{
            display: 'grid',
            gridTemplateColumns: { base: '1fr 1fr', lg: `repeat(${cellsCount}, 1fr)` },
            gap: { base: 4, lg: 8 },
          }}
        >
          <InsuranceSummaryItem label="Pojistník" value={formatPersonFullName(ph!)} />
          <InsuranceSummaryItem label={getRcIcoHeader(ph!)} value={getRcIcoValue(ph!)} />
          <InsuranceSummaryItem label="Telefonní číslo" value={(<a href={`tel:${phone}`}>{phone}</a>)} />

          {
            version == 'standart' && <>
              <InsuranceSummaryItem label="Číslo pojistné smlouvy" value={insuranceParams.generalParams.contractNumber} />
              <InsuranceSummaryItem label="Počátek pojištění" value={moment(new Date(insuranceParams.generalParams.insuranceStartDate!)).format('D. M. YYYY HH:mm')} />
            </>
          }

          {/* Dle CESTOVKA-179 chtějí mít konec jako datum + minutu před půlnocí */}
          {app == 'cestovko' && (insuranceParams as InsuranceParamsTravelDto)?.travel.insuranceEndDate &&
            <InsuranceSummaryItem label="Konec pojištění" value={moment(new Date((insuranceParams as InsuranceParamsTravelDto).travel.insuranceEndDate!)).format('D. M. YYYY 23:59')} />
          }

          {/* <InsuranceSummaryItem
            label="Splatnost 1. pojistného"
            value={formatDate({ date: new Date(2022, 0, 31) })}
          /> */}
        </CardBody>
      }
    </Card>
  )
}
